/**
 * Payload para criar/atualizar Operations (Segmentos de Negócio)
 *
 * Endpoint: POST /api/v1/operations
 * Backend: SaveSegmentBussinessRequest.kt
 */
export interface ICreateOperationPayload {
  /** ID da operação (null para criar, preenchido para atualizar) */
  id?: number | null;

  /** Nome da operação - OBRIGATÓRIO */
  name: string;

  /**
   * Segmento de negócio - OBRIGATÓRIO
   * Valores válidos: Agronegocio, Alimentos e Bebidas, Automotivo,
   * Construcao, Eletricitario, Florestal, Industria Geral, Locacao,
   * Logistica, Mineracao, Petroleo/Quimico, Sucroenergetico
   */
  segment: string;

  /** Status ativo/inativo (default: true) */
  active?: boolean;

  /** ID da filial associada (opcional) */
  branchId?: number | null;
}

/**
 * Response de Operation retornada pelo backend
 */
export interface IOperationResponse {
  id: number;
  name: string;
  segment: string;
  active: boolean;
  branchId?: number | null;
  branchName?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Lista de segmentos de negócio disponíveis
 * (pré-definidos no backend via migration V14)
 */
export const BUSINESS_SEGMENTS = [
  'Agronegocio',
  'Alimentos e Bebidas',
  'Automotivo',
  'Construcao',
  'Eletricitario',
  'Florestal',
  'Industria Geral',
  'Locacao',
  'Logistica',
  'Mineracao',
  'Petroleo/Quimico',
  'Sucroenergetico',
] as const;

export type BusinessSegment = typeof BUSINESS_SEGMENTS[number];
